export default __webpack_public_path__ + "static/media/quotation.97bdae59.svg";